<template>
	<div class="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8" v-if="form">
		<div class="sm:mx-auto sm:w-full sm:max-w-sm">
			<router-link :to="{name:'landing'}">
				<img class="mx-auto w-auto"
				     src="/images/logos/haldex.png"
				     alt="Haldex"/>
			</router-link>
			<h2 class="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
				{{ message ?? $t('pages.auth.reset_password_view.enter_a_new_password_below_to_change_your_password') }}
			</h2>
		</div>

		<div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
			<form v-if="!message" class="space-y-6" @submit.prevent="submitForm">
				<!-- Error message below the input -->
				<p v-if="form.errors?.email" class="text-sm text-red-600">{{ form.errors.email }}</p>

				<div class="flex flex-col gap-6">
					<FormGroup :label="$t('pages.auth.reset_password_view.new_password')" :error-text="form.errors?.password">
					<Password
							ref="password"
							v-model="form.password"
							placeholder="********"
							toggleMask
							inputClass="w-full"
					/>
					</FormGroup>

					<FormGroup :label="$t('pages.auth.reset_password_view.confirm_password')" :error-text="form.errors?.password_confirmation">
					<Password
							ref="password_confirmation"
							v-model="form.password_confirmation"
							placeholder="********"
							toggleMask
							inputClass="w-full"
					/>
					</FormGroup>
				</div>
				<div>
					<Button type="submit"
					        class="w-full">
						{{ $t('pages.auth.reset_password_view.change_password') }}
					</Button>
				</div>
			</form>

			<p class="mt-8 text-center">
				<router-link :to="{ name: 'login' }">
					<Button :label="$t('pages.auth.reset_password_view.go_to_login')" link/>
				</router-link>
			</p>

		</div>
	</div>
</template>

<script>
import FormGroup from "@/Components/FormGroup.vue";

export default {
	components: {FormGroup},
	data() {
		return {
			form: null,
			message: null,
		}
	},
	async mounted() {
		this.form = await this.$auth.getPasswordResetForm({ token: this.$route.params.token, email: this.$route.query.email });
	},
	methods: {
		async submitForm() {
			try {
				const response = await this.form.submit();
				this.message = response.data.status;
			} catch (e) {
				console.log(e);
			}
		}
	},
}
</script>

<style scoped>

</style>